import { render, staticRenderFns } from "./extAttrItem.vue?vue&type=template&id=3bc00420&scoped=true&"
import script from "./extAttrItem.vue?vue&type=script&lang=js&"
export * from "./extAttrItem.vue?vue&type=script&lang=js&"
import style0 from "./extAttrItem.vue?vue&type=style&index=0&id=3bc00420&lang=scss&scoped=true&"
import style1 from "./extAttrItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc00420",
  null
  
)

export default component.exports